// src/components/Common/Input.js

import React from 'react';
import PropTypes from 'prop-types';

/**
 * Reusable Input component with optional icons.
 */
const Input = ({
  type,
  placeholder,
  value,
  onChange,
  icon,
  rightIcon,
  required,
  ariaLabel,
  ...props
}) => {
  return (
    <div className="relative">
      {/* Left Icon */}
      {icon && (
        <span className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none text-accent">
          {icon}
        </span>
      )}

      {/* Input Field */}
      <input
        type={type}
        placeholder={placeholder}
        value={value}
        onChange={onChange}
        required={required}
        aria-label={ariaLabel}
        className={`py-3 bg-gray-800 text-white rounded-md w-full focus:ring-4 focus:ring-accentBlue transition duration-300 ${
          icon ? 'pl-12' : 'pl-4'
        } ${rightIcon ? 'pr-12' : 'pr-4'} autofill:bg-gray-800 autofill:text-white`}
        {...props}
      />

      {/* Right Icon */}
      {rightIcon && (
        <span className="absolute inset-y-0 right-0 pr-3 flex items-center text-accent">
          {rightIcon}
        </span>
      )}
    </div>
  );
};

Input.propTypes = {
  type: PropTypes.string.isRequired,
  placeholder: PropTypes.string,
  value: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number,
  ]).isRequired,
  onChange: PropTypes.func.isRequired,
  icon: PropTypes.element,
  rightIcon: PropTypes.element,
  required: PropTypes.bool,
  ariaLabel: PropTypes.string.isRequired,
};

Input.defaultProps = {
  placeholder: '',
  icon: null,
  rightIcon: null,
  required: false,
};

export default Input;
